
    import Vue from 'vue';
    import Component from "vue-class-component";
    import HeadingWave from "../../shared/components/HeadingWave.vue";
    import SectionPageHeading from "../../shared/components/sections/SectionPageHeading.vue";
    import HeadingGroup from "../../shared/components/HeadingGroup.vue";
    import {
        ApiException,
        CountryLightModel,
        DocumentAttributesClient,
        factory,
        ResultError,
        SeafarerDocumentsModel,
        SeafarerDocumentsQueryClient
    } from "@/api-client";
    import Certificate from "@/features/documents/query/components/Certificate.vue";
    import Endorsement from "@/features/documents/query/components/Endorsement.vue";
    import MedicalCertificate from "@/features/documents/query/components/MedicalCertificate.vue";
    import {Prop} from "vue-property-decorator";
    import Loader from "@/features/shared/components/Loader";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import {ls} from "@/CultureService";
    import toasts from "@/components/Toasts";


    @Component({
        components: {
            HeadingWave,
            SectionPageHeading,
            HeadingGroup,
            Certificate,
            Endorsement,
            MedicalCertificate,
            LoadingSpinner,
            LabelOptional
        },
        beforeRouteEnter (to, from, next: NavigationGuardNext<SeafarerDocumentsQuery>) {
            Promise.all([
                new DocumentAttributesClient().countries()
            ]).then(values => {
                to.meta!.props.countries = values[0];
                next();
            }).catch(e => next(e))
        }
    })
    export default class SeafarerDocumentsQuery extends Vue{
        @Prop({required: true})
        countries!: CountryLightModel[];

        seafarerDocuments:SeafarerDocumentsModel[] = [];

        firstName = "";
        lastName = "";
        birthDate: Date|null = null;
        nationality = "";
        personalCode = "";

        errors = factory.create(ResultError);
        loader = new Loader();

        async search(){
            this.seafarerDocuments = [];
            await new SeafarerDocumentsQueryClient().setLoader(this.loader).documents(this.firstName, this.lastName, this.nationality, this.birthDate, this.personalCode)
                .then(seafarerDocuments => {
                    this.errors.clear();
                    this.seafarerDocuments = seafarerDocuments;
                    toasts.success(this.$ls.Global_Toast_QuerySuccess);
                })
                .catch(error => this.handleErrors(error));
        }

        handleErrors(error: ResultError | ApiException): void {
            this.errors.clear();
            if (error instanceof ResultError) {
                this.setValidationErrors(error, this.$ls.Global_Toast_FormQueryFailure, "errors");
            }
            else if (error.status === 404) {
                const notFoundError = factory.create(ResultError);
                notFoundError.appendMessage(ls.Documents_Query_Validation_NotFound);
                this.setValidationErrors(notFoundError, null, "errors");
            }
            else
                throw error;
        }

        resetParameters(){
            this.errors.clear();
            this.firstName = "";
            this.lastName = "";
            this.birthDate = null;
            this.nationality = "";
            this.personalCode = "";
        }
    }
